import { defineMessages } from 'react-intl';
import type { BusinessModelEnum } from '@foundershub/api-client';

export const businessModelLabels = defineMessages<BusinessModelEnum>({
  b2b: { defaultMessage: 'B2B', description: 'acronym for "Business to Business"' },
  b2c: { defaultMessage: 'B2C', description: 'acronym for "Business to Customer"' },
});
